import React from 'react';
import { EVENTS, trackEvent } from '../../analytics/trackEvent';
import { useI18n } from '../../i18n/I18nContext';
import { Locale } from '../../i18n/types';
import './LanguageSwitcher.css';

export const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale, t } = useI18n();

  const options: { code: Locale; label: string }[] = [
    { code: 'en', label: 'EN' },
    { code: 'es', label: 'ES' },
  ];

  return (
    <nav className='language-switcher' aria-label={t.languageSwitcherLabel}>
      <ul>
        {options.map(({ code, label }) => (
          <li key={code}>
            <button
              type='button'
              className={locale === code ? 'active' : ''}
              onClick={() => {
                trackEvent(EVENTS.LOCALE, { locale: code });
                setLocale(code);
              }}
              aria-pressed={locale === code}
              aria-label={code === 'en' ? t.languageEn : t.languageEs}
              lang={code}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};
